export default __webpack_public_path__ + "static/media/Halo-logo.0deb09a1.svg";